<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import Product from '@maison/components/common/Product';
import { TAB_PRODUCTS } from '@maison/helpers/search-helper';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';

export default {
  components: {
    SearchResultsTab,
    Product,
  },

  mixins: [searchResultsTabMixin],

  data() {
    return {
      tab: TAB_PRODUCTS,
    };
  },

  methods: {
    onProductClick(product, position) {
      algoliaTracking(product, position, IndexNames.Products);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit" has-paging-label>
    <div class="mixed-grid mixed-grid--center">
      <div
        v-for="(product, position) in items"
        :key="product.modelReference"
        class="mixed-grid__item mixed-grid__item--1/2 lg:mixed-grid__item--1/4"
      >
        <product v-bind="product" :data-tracking="dataTracking" @click="onProductClick(product, position)" />
      </div>
    </div>
  </search-results-tab>
</template>
